import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const featuredPrograms = [{
  title: 'Beginner Tae Kwon Do',
  summary: 'Perfect for ages 5+, learn fundamentals while building discipline and confidence.',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/Classes/BEGINNER%20TAE%20KWON%20DO.png'
}, {
  title: 'Intermediate Taekwondo',
  summary: 'Advanced techniques, sparring, and forms for developing martial artists.',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/Classes/INTERMEDIATE%20TAEKWONDO.png'
}, {
  title: 'Family Class',
  summary: 'Train together as a family and strengthen bonds while getting fit.',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/Classes/FAMILY%20CLASS.png'
}, {
  title: 'Black Belt & Bodan Program',
  summary: 'Elite training for upper belts developing leadership and mastery.',
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/Classes/BLACK%20BELT%20%26%20BODAN%20PROGRAM.png'
}];
export function ProgramsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-627">
      <div className="max-w-6xl mx-auto" data-id="element-628">
        <div className="text-center mb-12" data-id="element-629">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-630">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-[#0f1f3d] mb-4" data-id="element-631">
              Our Programs
            </h2>
            <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-632"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-633">
              Discover our comprehensive martial arts classes designed for all
              ages and skill levels. From beginners to black belts, we offer
              expert instruction in traditional Taekwondo and competitive
              training programs.
            </p>
          </motion.div>
        </div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-634">
          {featuredPrograms.map((program, idx) => <motion.div key={idx} variants={fadeIn} className="bg-white rounded-xl overflow-hidden shadow-lg border-2 border-[#a3d977]/20 hover:border-[#a3d977]/40 transition-all hover:shadow-xl" data-id="element-635">
              <div className="aspect-[4/3] overflow-hidden" data-id="element-636">
                <img src={program.image} alt={program.title} className="w-full h-full object-cover object-top" data-id="element-637" />
              </div>
              <div className="p-6" data-id="element-638">
                <h3 className="text-lg font-bold text-[#0f1f3d] mb-2" data-id="element-639">
                  {program.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-640">
                  {program.summary}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center" data-id="element-641">
          <Link to="/classes" className="inline-flex items-center gap-2 px-8 py-4 bg-[#1e3a8a] text-white text-lg font-bold rounded-lg shadow-lg hover:bg-blue-900 transition-colors border-2 border-[#a3d977]/30" data-id="element-642">
            See All Our Classes
            <ArrowRight className="w-5 h-5" data-id="element-643" />
          </Link>
        </motion.div>
      </div>
    </section>;
}